import useSWR from "swr";
import { API, graphqlOperation } from "aws-amplify";
import { kdsGetWarungLandingPage } from "@/graphql/queries";
import { useState } from "react";

export function getStoreOperatingHours(merchantId) {
  if (!merchantId) {
    throw new Error("merchantId is required");
  }

  const [landingPageFetchStatus, setLandingPageFetchStatus] = useState("none");

  const fetcher = async () => {
    try {
      setLandingPageFetchStatus("loading");
      const { data } = await API.graphql(
        graphqlOperation(kdsGetWarungLandingPage, {
          merchantId: merchantId,
        })
      );
      const status = data?.kdsGetWarungLandingPage.status;

      if (status === false) {
        return {};
      }
      setLandingPageFetchStatus("loaded");
      return {
        address: data?.kdsGetWarungLandingPage.address,
        operatingHours: data?.kdsGetWarungLandingPage.item,
        warungStoreStatus: data?.kdsGetWarungLandingPage.warungStoreStatus,
        orderOption: data?.kdsGetWarungLandingPage.orderOption,
      };
    } catch (err) {
      console.log("err", err);
      setLandingPageFetchStatus("error");
      return null;
    }
  };
  const { data: landingPageData } = useSWR("kdsGetWarungLandingPage", fetcher);
  return { landingPageData, landingPageFetchStatus };
}
